export const MOUNT_ELEMENT_ID = 'age-verification-root';

export const STATUS_PENDING_APPROVAL = 'pending_approval';
export const STATUS_PENDING_USER_INFO = 'pending_user_info';
export const STATUS_PENDING_REVIEW = 'pending_review';
export const STATUS_FAILED = 'failed';
export const STATUS_VERIFIED = 'verified';

export const STEP_DOB_NAME = 'dob_name';
export const STEP_ADDRESS = 'address';
export const STEP_ADDRESS_RETRY = 'address_retry';
export const STEP_ID_PHOTOS = 'id_photos';
export const STEP_ID_PHOTOS_RETRY = 'id_photos_retry';

export const MODAL_RESULT_APPROVED = 'APPROVED';
export const MODAL_RESULT_INFO_ACQUIRED = 'INFO_ACQUIRED';
export const MODAL_RESULT_CLOSE_IFRAME = 'CLOSE_IFRAME';

export const US = 'US';
export const GB = 'GB';
export const IL = 'IL';
export const FR = 'FR';
export const CH = 'CH';
export const DE = 'DE';
export const RU = 'RU';

export const ADDRESS_FIELD_ADDRESS1 = 'address1';
export const ADDRESS_FIELD_ADDRESS2 = 'address2';
export const ADDRESS_FIELD_CITY = 'city';
export const ADDRESS_FIELD_STATE = 'state';
export const ADDRESS_FIELD_ZIP = 'zip';
export const ADDRESS_FIELD_GENDER = 'gender';

export const FAILURE_TYPE_DUPLICATE_DOCUMENT = 'duplicate_document';

export const ALTERNATE = 'alternate';
export const FULL = 'full';

export const AV_NATIONAL_ID_TYPES = {
  TAX_CODE: 'tax_code',
  PASSPORT: 'passport',
  LAST_4_SSN: 'last_4_ssn',
  DRIVERS_LICENSE: 'drivers_license',
};
